import $ from "jquery";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

$(function() {
    $(".bl-teaserboxes").each(function() {
        initBlock($(this));
    });
});

function initBlock($bl) {
    const $ctrswipernavigation = $bl.find(".ctrswipernavigation");

    const swiper = new Swiper($bl.find(".swiper").get(0), {
      //loop: true,
      //rewind: true,
      //autoHeight: true,
      
      /*
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      */
    
      navigation: {
        prevEl: $ctrswipernavigation.find(".icon-arrowleft").get(0),
        nextEl: $ctrswipernavigation.find(".icon-arrowright").get(0),
      },

      /*
      speed: 1500,
      autoplay: {
        delay: 4000
      }
      */

      spaceBetween: 20,

      breakpoints: {
        740: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 3
        }
      }

    });
}

